function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 5");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M30.8436076,25.841119 L21.5407576,31.8215226 C21.0761875,32.1201747 20.4574737,31.9856717 20.1588215,31.5211017 C20.0551304,31.3598044 20,31.1720957 20,30.9803441 L20,19.019537 C20,18.4672522 20.4477153,18.019537 21,18.019537 C21.1917516,18.019537 21.3794603,18.0746673 21.5407576,18.1783585 L30.8436076,24.1587621 C31.3081776,24.4574142 31.4426806,25.0761281 31.1440285,25.5406981 C31.0665625,25.6612008 30.9641102,25.763653 30.8436076,25.841119 Z",
  id: "path-1"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "E4H/videos",
  transform: "translate(-626.000000, -1597.000000)"
}, React.createElement("g", {
  id: "Group-6"
}, React.createElement("g", {
  id: "Group-4-Copy-2",
  transform: "translate(489.000000, 1524.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(137.000000, 73.000000)"
}, React.createElement("g", {
  id: "Group-5"
}, React.createElement("path", {
  d: "M25,0 C38.8071187,-2.53632657e-15 50,11.1928813 50,25 C50,38.8071187 38.8071187,50 25,50 C11.1928813,50 1.69088438e-15,38.8071187 0,25 C-1.69088438e-15,11.1928813 11.1928813,2.53632657e-15 25,0 Z",
  id: "Front-layer---Style-\\uD83C\\uDF08",
  fill: "#00458C"
}), React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "Mask",
  fill: "#FFFFFF",
  xlinkHref: "#path-1"
})))))));

var SvgPlayButton = function SvgPlayButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlayButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play_button.9304096c.svg";
export { ForwardRef as ReactComponent };